export { default as MyCoursesWithRules } from './LazyMyCoursesWithRules';
export type { MyCoursesWithRulesProps } from './types';
